import { ColumnDefinition, GridSlicerTypes } from 'features/gridReport/models';

export function getMainCount(filterableColumns: ColumnDefinition[]): number {
  const firstSix = filterableColumns.slice(0, 6);
  const conditionalIndex = firstSix.findIndex(
    col => col.filter_type === GridSlicerTypes.CONDITIONAL
  );
  const dateIndex = firstSix.findIndex(
    col => col.filter_type === GridSlicerTypes.DATE_PICKER
  );
  const hasConditional = conditionalIndex !== -1;
  const hasDate = dateIndex !== -1;

  if (hasConditional && hasDate) {
    const maxIndex = Math.max(conditionalIndex, dateIndex);
    // If either is in 5th/6th position (index 4 or 5), keep main count at 5
    return maxIndex >= 4 ? 5 : 4;
  }

  if (hasConditional || hasDate) {
    return 5;
  }

  return 6;
}
